import shippingService from '../service/shipping'
const state = {
    query: {
        macAddress: "",
        customer: "",
        page: 1,
        pageSize: 10,
    },
    searchResult: {
        total: 0,
        shippings: [],
    },
    loading: false
}

const actions = {
    updateShipping({ commit }, shipping) {
        commit('setLoading', true)
        return shippingService.updateShipping(shipping).then(data => {
            commit('setShipping', shipping);
            return data;
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    createShipping({ commit }, shipping) {
        return shippingService.createShipping(shipping).then(data => {
            shipping._id = data._id;
            commit('addShipping', shipping);
            return data;
        })
    },
    getShippings({ commit }, query) {
        commit('setLoading', true)
        return shippingService.getShippings(query).then(shippings => {
            commit('setShippings', shippings);
        }).catch(() => {
            commit('setLoading', false)
        })
    },
    sendMailShippings({commit }, shipping) {
        commit('setLoading', false)
        return shippingService.sendMailShippings(shipping)
    },
}
const mutations = {
    addShipping(state, shipping) {
        state.searchResult.shippings.push(shipping)
        state.searchResult.total++;
    },
    setShipping(state, shipping) {
        let index = state.searchResult.shippings.findIndex(x => x._id == shipping._id)
        if (index != -1) {
            state.searchResult.shippings[index].status = shipping.newStatus
        }
    },
    setLoading(state, loading) {
        state.loading = loading
    },
    setShippings(state, shippings) {
        state.searchResult = shippings
        state.loading = false
    },

}
export default {
    namespaced: true,
    state,
    actions,
    mutations
}



